export const root_support = {
  data() {
    return {
    }
  },
}
